<!--header-right-->
<template>
  <div class="home-business-card-intl-hotel-guest">
    <div class="line"></div>
    <div class="guest-item" v-for="index in RoomAmount" :key="`roomAmount${index}`">
      <div class="guest-item-header">
        <span>{{index}}</span>{{$t('GuestRoom_x', 'function', [index])}}
      </div>
      <div class="guest-item-content" @click="$emit('add', index)">
        <div class="add-guest" :style="{backgroundImage: `url(${require('@/assets/image/base/add/icons_24pt_add_red.svg')})`}"></div>
        <div class="guest-item-content-box">
          <div class="guest-item-content-box-cell" v-for="n in AdultAmount" :key="n">
            <template v-if="Guests.filter((v) => v.GuestToRoomNo === index)[n - 1]">
              <div class="name">{{$getPassengerName(Guests.filter((v) => v.GuestToRoomNo === index)[n - 1]) || '--'}}</div>
              <span
                  class="delete"
                  :style="{backgroundImage: `url(${require('@/assets/image/base/close/icons_24pt_close.svg')})`}"
                  @click.stop="$emit('delete', Guests.filter((v) => v.GuestToRoomNo === index)[n - 1])"
              ></span>
            </template>
            <template v-else>
              <div class="gray">
                {{n === 1 ? $t("MainRoomerRequired") : $t('Roomer')}}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    RoomAmount: {
      type: Number,
      default: 0
    },
    AdultAmount: {
      type: Number,
      default: 0
    },
    Guests: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
/** 超标支付样式  */
.home-business-card-intl-hotel-guest
  width calc(100% + 16px)
  color $color_black_900
  >.line
    width calc(100% + 16px)
    margin-left -16px
    height 8px
    background-color $color_black_10
  >.guest-item
    width 100%
    position relative
    &:after
      position absolute
      content ' '
      width calc(100% + 16px)
      margin-left -16px
      height 1px
      box-shadow 0px -0.5px 0px 0px $color_black_30 inset
    &:last-child
      &:after
        box-shadow none
    >.guest-item-header
      @extend .flex-start
      @extend .hs-font-body-note-1
      width 100%
      min-height 56px
      padding-right 16px
      box-shadow 0px -0.5px 0px 0px $color_black_30 inset
      >span
        @extend .flex-center
        width 16px
        height 16px
        border-radius 4px
        margin-right 4px
        background $color_theme_300
        color $color_black_0
        font-size 12px
        font-weight 500
    >.guest-item-content
      @extend .flex-start
      @extend .hs-font-body-note-1
      >.add-guest
        width 48px
        height 48px
        border-radius 8px
        flex-shrink 0
        background-color rgba(240, 24, 42, 0.04)
        background-size 24px 24px
        background-repeat no-repeat
        background-position center
        margin-right 16px
      >.guest-item-content-box
        width calc(100% - 64px)
        >.guest-item-content-box-cell
          @extend .flex-start
          width 100%
          min-height 56px
          box-shadow 0px -0.5px 0px 0px $color_black_30 inset
          padding-right 16px
          &:last-child
            box-shadow none
          >.name
            ellipsis(1)
            width 100%
          >.gray
            ellipsis(1)
            color $color_black_50
          >.delete
            flex-shrink 0
            width 24px
            height 24px
            background-size 100% 100%
            background-position no-repeat
</style>
